import React from 'react';
import { Box, Flex, Heading, IconButton, Text } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'phosphor-react';
import { useNavigate } from 'react-router-dom';

import { GlassCard, GlassPageBg } from '../../../../../components/glass';
import { ImportarExtratoContent } from '../components/ImportarExtratoContent';

/**
 * Pagina standalone de importar (deep-link). O fluxo principal abre via
 * modal a partir do dashboard; esta rota reusa o mesmo conteudo.
 */
export function ConciliacaoContabilImportarPage() {
  const navigate = useNavigate();
  return (
    <GlassPageBg>
      <Box maxW="900px" mx="auto" w="full" px={{ base: 4, md: 8 }} py={{ base: 6, md: 10 }}>
        <motion.div
          initial={{ opacity: 0, y: -16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.45, ease: [0.4, 0, 0.2, 1] }}
        >
          <Flex align="center" gap={3} mb={5}>
            <IconButton
              aria-label="Voltar"
              icon={<ArrowLeft size={18} weight="bold" />}
              variant="ghost"
              size="sm"
              borderRadius="full"
              color="#64748B"
              _hover={{ bg: 'rgba(15, 23, 42, 0.06)', color: '#0F172A' }}
              onClick={() => navigate('/modulesHome/accountingConciliation/conciliacao-contabil')}
            />
            <Box>
              <Text
                fontSize="11px"
                color="#94A3B8"
                textTransform="uppercase"
                letterSpacing="0.1em"
                fontWeight="semibold"
              >
                Conciliação Contábil
              </Text>
              <Heading fontSize={{ base: '22px', md: '28px' }} fontWeight="700" color="#0F172A">
                Importar extrato
              </Heading>
            </Box>
          </Flex>
        </motion.div>

        <GlassCard intensity="strong" p={{ base: 5, md: 6 }}>
          <ImportarExtratoContent />
        </GlassCard>
      </Box>
    </GlassPageBg>
  );
}
